import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ButtonComponent, DatepickerComponent } from '@ppl/ui';
import { NzColDirective, NzRowDirective } from 'ng-zorro-antd/grid';
import {
  NzFormControlComponent,
  NzFormDirective,
  NzFormItemComponent
} from 'ng-zorro-antd/form';
import { NzOptionComponent, NzSelectComponent } from 'ng-zorro-antd/select';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { LookupValueItem } from '../../../../interfaces/lookup.interface';
import { LookupService } from '../../../../services/lookup.service';
import { DateTimeFormatterService } from '../../../../shared/utils/date-time-formatter.service';
import { UserService } from '../../../../services/user.service';
import { AuthorizeDirective } from '../../../../shared/authorization/authorize.directive.';

@Component({
  selector: 'ppl-purchase-filter',
  standalone: true,
  imports: [
    ButtonComponent,
    DatepickerComponent,
    NzColDirective,
    NzFormControlComponent,
    NzFormDirective,
    NzFormItemComponent,
    NzOptionComponent,
    NzRowDirective,
    NzSelectComponent,
    ReactiveFormsModule,
    CommonModule,
    AuthorizeDirective
  ],
  templateUrl: './purchase-filter.component.html',
  styleUrls: ['./purchase-filter.component.css']
})
export class PurchaseAdjustmentFilterComponent implements OnInit {
  @Input() pageId: string = '';
  @Output() searchEvent = new EventEmitter<any>();

  purchaseFilterForm!: FormGroup;
  serviceCodes: LookupValueItem[] = [];

  tabId: string = '';

  loopback = [
    { label: '30 days', val: this.getDateBefore(30) },
    { label: '60 days', val: this.getDateBefore(60) },
    { label: '90 days', val: this.getDateBefore(90) },
    { label: '120 days', val: this.getDateBefore(120) },
    { label: '150 days', val: this.getDateBefore(150) },
    { label: '180 days', val: this.getDateBefore(180) },
    { label: '1 year', val: this.getDateBefore(365) },
    { label: '2 years', val: this.getDateBefore(730) },
    { label: '3 years', val: this.getDateBefore(1095) },
  ];

  constructor(
    private fb: FormBuilder,
    private lookupService: LookupService,
    private dateTimeFormatter: DateTimeFormatterService,
    private userService: UserService
  ) { }

  ngOnInit(): void {
    // Purchase filter fields: Timeframe, consumer, consumerPplId,
    //                         provider, providerPplId, serviceCode
    // No serviceDate for purchase
    this.purchaseFilterForm = this.fb.group({
      Timeframe: [this.getDateBefore(30)],
      submissionDate: [null],
      pplPurchaseId: [null],
      consumer: [null],
      consumerPplId: [null],
      serviceCode: [null],
      // crmNumber: [null] // temporarily hidden, may be reintroduced later
    });

    const serviceCodes = this.lookupService.getLookupValue('timesheet_filter_serviceCode');
    serviceCodes.forEach((code: any) => {
      code.label = `${code.lkpValueCode} - ${code.lkpValueName}`;
    });
    this.serviceCodes = serviceCodes;
  }

  search(): void {
    this.searchEvent.emit(this.purchaseFilterForm.getRawValue());
  }

  getDateBefore(days: number): string {
    const date = new Date();
    date.setDate(date.getDate() - days);
    return date.toLocaleDateString('en-US');
  }
}